import script from "./remap-inline-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./remap-inline-item.vue?vue&type=script&setup=true&lang=ts"

import "./remap-inline-item.vue?vue&type=style&index=0&id=b6e9d202&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6e9d202"]])

export default __exports__